module.exports = __webpack_public_path__ + "static/img/3.9fb0f07.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/app/3.png
// module id = 4iOo
// module chunks = 1